import { z } from "zod";

export enum UserPolicy {
  blockedFromCommunity = 1,
  accessTeacherResourceSite = 2,
  viewSchoolsHomepage = 3,
  /** @deprecated */
  deletableByCommunityAdmin = 4,
  cantChangeEmail = 5,
  blockedFromMagicLinkAuth = 6,
  blockedFromDMs = 7,
  blockedFromFriends = 8,
  blockedFromPurchasing = 9,
  blockedFromManagingProfiles = 12,
}

export const userPolicyEnum = z.enum(UserPolicy);
